@if (inputControl) { @for (tab of tabs(); track tab.id) {
<button
    [attr.data-testid]="currentTestId() + '-' + tab.value"
    [attr.data-styleTarget]="tab.id"
    [attr.data-styleSelected]="tab?.value === inputValue()?.value"
    [attr.data-styleDisabled]="tab?.disabled || disabled()"
    [attr.data-styleTarget]="tab.id"
    class="rounded-md px-2 mr-2 font-body-2 h-6"
    [class.bg-dat-grey-050]="tab?.value !== inputValue()?.value"
    [class.!bg-dat-blue-050]="tab?.value === inputValue()?.value"
    [class.text-dat-blue-700]="tab?.value === inputValue()?.value"
    [class.opacity-40]="tab?.disabled || disabled()"
    [class.cursor-not-allowed]="tab?.disabled || disabled()"
    [attr.data-uiType]="'tab'"
    (click)="tabClick(tab)"
    [disabled]="tab?.disabled || disabled()"
>   
    <div class="flex items-center">
        <span>
            @if(tab && tab.data) {
                <iq-builder-label
                    [id]="tab.id"
                    [type]="tab.data.type"
                    [label]="tab.data.label"
                    [tooltipBody]="tab.data.tooltipBody"
                    [tooltipHeader]="tab.data.tooltipHeader"
                    [openOnClick]="tab.data.openOnClick"
                    (toolTipClick)="handleTooltipClick(tab)"
                />
            }
        </span>
        <span [datiqTemplateMd]="tab.display" class="iq-md"></span>
    </div>
</button>
} }
